import React, { useEffect, useState, useCallback } from 'react';
import { Outlet } from 'react-router-dom';
import { IdleTimerProvider } from 'react-idle-timer';
import SideNav from '../../components/organisms/SideNav';
import TopNav from '../../components/organisms/TopNav';
import MobileNav from '../../components/organisms/MobileNav';
import { getValues } from 'services/storage';
import { handleLogout } from 'utils';
import moment from 'moment';
import RefreshUserSession from './ModalComponents/RefreshUserSession';
import { connect } from 'react-redux';

const Dashboard = React.memo((props:any) => {
  const [showModal, setShowModal] = useState(false);
  const [currentTime, setCurrentTime] = useState(new Date());

  const authToken_available = props.userData.token.token;
  const expireAt = getValues('expiredAt');

  useEffect(() => {
    if (authToken_available === null) handleLogout();
  }, [authToken_available]);

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  useEffect(() => {
    if (expireAt) {
      const currentMoment = moment(currentTime);
      const expireMoment = moment(expireAt);

      if (currentMoment.isSameOrAfter(expireMoment)) {
        setShowModal(true);
      }
    }
  }, [currentTime, expireAt]);

  const handleCloseModal = useCallback(() => {
    setShowModal(false);
  }, []);

  return (
    <IdleTimerProvider timeout={1000 * 600} onIdle={handleLogout}>
      <div className='flex w-full min-h-screen desktop:flex-row mobile:flex-col'>
        <div className='relative w-3/12 min-h-screen bg-black desktop:w-2/12 mobile:hidden'>
          <SideNav />
        </div>
        <div className='relative flex flex-col w-9/12 h-full min-h-screen overflow-x-hidden desktop:w-full mobile:w-full'>
          <div className='mobile:hidden h-[8vh]'>
            <TopNav />
          </div>
          <div className={`hidden mobile:flex shadow justify-between items-center py-5 px-8 h-[8vh]`}>
            <MobileNav />
          </div>
          <div className={`px-8 py-5 min-h-[92vh] h-full relative bg-AppBg`}>
            <Outlet />
          </div>
        </div>
      </div>
      {showModal && (
        <RefreshUserSession closeModal={handleCloseModal} />
      )}
    </IdleTimerProvider>
  );
});

const mapStateToProps = (state) => ({
  userData: state.auth?.user_authData,
  modal_state: state.app.modal_state,
  expTime: state.auth?.user_authData.token.expiredAt,
});

export default connect(mapStateToProps)(Dashboard);